<style scoped>
    .table-column-1 {
        width: 40%;
    }
</style>

<template>
    <data-table
        table-id="pending_table"
        table-label="Invited to Register"
        :items="pendingInvites"
        :fields="fields"
        empty-text="You don't have any pending invitations to connect"
        :show-search-input="true"
        :show-items-per-page-select="true"
    >
        <template #invited_at="{ item }">
            {{ formatDate(item.invited_at) }}
        </template>
        <template #last_resent_at="{ item }">
            {{ formatDate(item.last_resent_at) }}
        </template>
        <template #resend-invite="{ item }">
            <button class="btn-orange-blue btn-xs" @click="resendInvite(item)"><small>Resend</small></button>
        </template>
        <template #disconnect="{ item }">
            <a class="btn-orange-blue btn-sm" @click.prevent="deleteInvite(item)">Disconnect</a>
            <a class="btn-x" @click.prevent="deleteInvite(item)"><i class="fa fa-times" aria-hidden="true"></i></a>
        </template>
    </data-table>
</template>

<script>
    import DataTable from '../../DataTable.vue';

    export default {
        components: {
            DataTable,
        },
        props: {
            sortBy: {
                required: false,
                default: 'user-info',
                type: String
            },
            sortDesc: {
                required: false,
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                pendingInvites: [],
                fields: [
                    {
                        key: 'to_name',
                        label: 'User Information',
                        sortable: true,
                        compareFn: 'compareByKey',
                        thStyle: { width: '40%' }
                    },
                    {
                        key: 'invited_at',
                        label: 'Date First Invited',
                        sortable: true,
                        compareFn: 'compareDateByKey',
                        formatFn: 'formatDate',
                        formatOptions: {
                            'format': 'MM/DD/YY'
                        }
                    },
                    {
                        key: 'last_resent_at',
                        label: 'Date of Last Invite',
                        sortable: true,
                        compareFn: 'compareDateByKey',
                        formatFn: 'formatDate',
                        formatOptions: {
                            'format': 'MM/DD/YY'
                        }
                    },
                    {
                        key: 'resend-invite',
                        label: 'Resend Invitation',
                    },
                    {
                        key: 'disconnect',
                        label: 'Disconnect',
                        sortable: false
                    }
                ],
            }
        },
        methods: {
            updateData() {
                // TODO: just remove the item from the list instead of reloading 
                window.location.reload();
            },
            deleteInvite(invite) {
                if (confirm('Are you sure you want to delete from this invite?')) {
                    axios.delete('/api/invites/'+invite.id)
                        .then(response => {
                            this.updateData()
                        })
                        .catch(error => {
                            if (error.response.status == 403) {
                                alert(error.response.data.message)
                            }
                        });
                }
            },
            resendInvite(invite) {
                axios.get('/consultants/resend-invite/'+invite.id)
                    .then(response => {
                        this.updateData();
                    });
            },
            getPendingInvites() {
                axios.get('/api/consultants/pending-invites')
                    .then(response => {
                        this.pendingInvites = response.data.data;
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            formatDate(dateString, format = 'MM/DD/YY') {
                if (moment(dateString).isValid()) {
                    return moment(dateString).utc().format(format)
                }
                return null
            }
        },
        created() {
            this.getPendingInvites();
        }
    
}
</script>